
import React from 'react';

interface SubscriptionHeaderProps {
  title: string;
  subtitle: string;
}

const SubscriptionHeader = ({ title, subtitle }: SubscriptionHeaderProps) => {
  return (
    <div className="text-center mb-12">
      <h1 className="text-4xl font-bold text-gray-900 mb-4">
        {title}
      </h1>
      <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
        {subtitle}
      </p>
    </div>
  );
};

export default SubscriptionHeader;
